import { MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`;

export const BtnWrapper = styled.div`
  width: 100%;
  position: fixed;
  z-index: 999;
  margin-top: 90vh;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    bottom: 4rem;
  }
`;

export const HomeBtn = styled.div`
  margin: 0 auto;

  width: 32rem;
  height: 5.6rem;
  background-color: ${MAIN_GREEN};
  border-radius: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  font-weight: 700;
  font-size: 2rem;
  line-height: 3.6rem;
  color: black;
  cursor: pointer;
  z-index: 9999;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-left: 3.8rem;
    font-size: 1.6rem;

    width: 30rem;
    height: 5rem;
  }
`;
